/* eslint-disable react/react-in-jsx-scope */
'use client'


import { Link } from "react-router"
import { useState, useContext } from 'react'
import { useCarts, useCartsDispatch } from '../contexts/CartContext';
import { useUserContext } from '../contexts/UserContext';
import { Dialog, DialogBackdrop, DialogPanel, DialogTitle } from '@headlessui/react'
import { XMarkIcon, ShoppingCartIcon,TrashIcon, PlusCircleIcon , MinusCircleIcon   } from '@heroicons/react/24/outline'
import TotalPrice from '../components/totalPrice'
import axios from 'axios';

function formatDateTime() {
  const now = new Date();

  const year = now.getFullYear(); // Get the year
  const month = String(now.getMonth() + 1).padStart(2, '0'); // Month is 0-indexed, so add 1
  const day = String(now.getDate()).padStart(2, '0'); // Day of the month

  const hours = String(now.getHours()).padStart(2, '0'); // Hours
  const minutes = String(now.getMinutes()).padStart(2, '0'); // Minutes
  const seconds = String(now.getSeconds()).padStart(2, '0'); // Seconds

  return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
}

const products = [
  {
    id: 1,
    name: 'Chocolate-Chiffon',
    href: '#',
    discount: '10',
    price: '$90.00',
    quantity: 1,
    imageSrc: 'https://craftstocrumbs.com/wp-content/uploads/2020/07/Chocolate-Chiffon-CTC-scaled.jpg',
    imageAlt: 'Chocolate-Chiffon',
  },
  {
    id: 2,
    name: 'blueberry-chiffon-cake',
    href: '#',
    discount: '10',
    price: '$32.00',
    quantity: 1,
    imageSrc: 'https://teakandthyme.com/wp-content/uploads/2024/10/blueberry-chiffon-cake-DSC_2632-1x1-1200.jpg',
    imageAlt:
      'blueberry-chiffon-cake',
  },
  {
    id: 3,
    name: 'Chiffon coconut',
    href: '#',
    discount: '10',
    price: '$90.00',
    quantity: 1,
    imageSrc: 'https://zhangcatherine.com/wp-content/uploads/2022/03/12001200.jpg',
    imageAlt: 'Chocolate-Chiffon',
  },
  {
    id: 4,
    name: 'chiffon-cake',
    href: '#',
    discount: '10',
    price: '$32.00',
    quantity: 1,
    imageSrc: 'https://cookingwithdog.com/wp-content/uploads/2021/03/chiffon-cake-00-1615696212.9265.jpg',
    imageAlt:
      'blueberry-chiffon-cake',
  },
  {
    id: 5,
    name: 'Citrus-Chiffon',
    href: '#',
    discount: '10',
    price: '$90.00',
    quantity: 1,
    imageSrc: 'https://bakefromscratch.com/wp-content/uploads/2022/05/Citrus-Chiffon-312JBweb.jpg',
    imageAlt: 'Chocolate-Chiffon',
  },
  {
    id: 6,
    name: 'Cake browny',
    href: '#',
    discount: '10',
    price: '$32.00',
    quantity: 1,
    imageSrc: 'https://www.allrecipes.com/thmb/JaPmyuRaOPDlGkkk0FwLKu2eoSo=/1500x0/filters:no_upscale():max_bytes(150000):strip_icc()/7892-chiffon-cake-ddmfs-11960-4x3-31cd0f36773640b193318e76a978cc0a.jpg',
    imageAlt:
      'blueberry-chiffon-cake',
  },
  {
    id: 7,
    name: 'Yellow Bowl Chiffon',
    href: '#',
    discount: '10',
    price: '$90.00',
    quantity: 1,
    imageSrc: 'https://assets.epicurious.com/photos/627aaf5f080d9862e3bda7d6/1:1/w_2560%2Cc_limit/PandanChiffon_RECIPE_050522_33403.jpg',
    imageAlt: 'Chocolate-Chiffon',
  },
  {
    id: 8,
    name: 'browny Choce',
    href: '#',
    discount: '10',
    price: '$32.00',
    quantity: 1,
    imageSrc: 'https://www.tasteofhome.com/wp-content/uploads/2018/01/exps164_MC163887B03_10_24b.jpg',
    imageAlt:
      'blueberry-chiffon-cake',
  },
  {
    id: 9,
    name: 'Cake browny',
    href: '#',
    discount: '10',
    price: '$32.00',
    quantity: 1,
    imageSrc: 'https://theunlikelybaker.com/wp-content/uploads/2017/10/Chocolate-Chiffon-Cake-Recipe-Feature.jpg',
    imageAlt:
      'blueberry-chiffon-cake',
  },
 // More products...
]

export default function Carts() {
  const [open, setOpen] = useState(true)
  const [totalPrice, SettotalPrice] = useState(0);
  // const cartQty = useContext(CartContext);
  // const cartQty = useCartsQty();
  const [saving, setSaving] = useState(false);
  const user = useUserContext();
  const cart = useCarts();
  const dispatch = useCartsDispatch();
  const [order, setOrder] = useState(
    {
      orderNo:0,
      date: formatDateTime(),
      operator: user.user?.name,
      uid: user.user?.id,
      tableno: 0,
      gettype: 'takehome',
      subtotal: 0,
      total: 0,
      paidtype:'',
      cart: cart,
    }
  )

  const apiurl = `${process.env.REACT_APP_API}`
  const imgurl = `${process.env.REACT_APP_URL}/image/products`

  if(cart.length===0) localStorage.removeItem("cart");

  function classNames(...classes) {
    return classes.filter(Boolean).join(' ')
  }

  const handleAddOrder = () => {
    const totalPrice = cart.reduce((sum, item) => sum + item.price * item.quantity, 0);
    setOrder({ ...order,
      // orderNo:0,
      date: formatDateTime(),
      operator: user.user?.name,
      uid: user.user?.id,
      // tableNo: 0,
      // gettype: 'takehome',
      subtotal: totalPrice,
      total: totalPrice,
      cart: cart,
    })
    const data = { 
      ...order, 
      mode: 'add',
      date: formatDateTime(),
      operator: user.user?.name,
      uid: user.user?.id,
      total: totalPrice,
      cart:cart,
    };

    saveData(data);

  };

  const saveData = async (data) => {
    setSaving(true);
    // console.log(data);
      //save to db
      try {
        const res = await axios({
                  method: 'post',
                  url: `${apiurl}/orders.php`,
                  headers: {
                      'Accept': 'application/json',
                      // 'Content-type': 'application/x-www-form-urlencoded',
                      // 'Content-type': 'application/json; charset=utf-8',
                      'Content-Type': 'multipart/form-data'
                  },
                  data: JSON.stringify(data) ,
                  // data: data,
              });

              // console.log(res);
              if(res.data?.success) {
                // console.log(res.data);
                setSaving(false);
                dispatch({
                  type: 'empty',
                  });
            
                // console.log("OK")
                // setresMessage("Register Success.");
                // setresMessage("Saved.");
                // setPwd("");
                // setcheckPwd("");
                // setpwdMatch(true);
                // setInput(() => ({
                //   email: "",
                //   name: "",
                // }));

                return true;
              } else {
                setSaving(false);
                return false;
              }

      } catch (error) {
        console.error("Error fetching invoice:", error);
        // setresMessage("Error!!!");
        setSaving(false);
        return false;
      }
  }


    // console.log(order);
  // console.log(cart);
  //  setCartQty(cart.length);

  return (
    <div className="flex flex-row sm:flex-col w-full sm:w-[220px] md:w-[250px] xl:w-[300px] h-[calc(100vh-50vh-136px)] sm:h-[calc(100vh-120px)] overflow-y-scroll bg-white shadow-xl">
      <div className="flex-1 overflow-y-auto px-2 py-2 sm:px-2">
        <div className="flex items-start justify-between">
          <div className="flex text-base font-medium  text-gray-900">
              <p>Shopping cart</p>
            <a
              // type="button"
              href="/cuscart"
              alt="CustomerCart"
              target="_blank"
              className="relative pl-2 text-gray-400 hover:text-white focus:outline-none focus:ring-2 focus:ring-white focus:ring-offset-2 focus:ring-offset-gray-800"
            >
              {/* <span className="absolute -inset-1.5" /> */}
              <span className="sr-only">View carts</span>
              <ShoppingCartIcon aria-hidden="true" className="h-6 w-6 text-gray-500" />
              <div className="relative">
                <span className="flex rounded-full text-[10px] text-center justify-center items-center -top-6 left-6  bg-emerald-500 text-white h-[18px] w-[18px] absolute"
                >{cart.length}</span>
              </div>
            </a>
          </div>

        </div>

        <div className="mt-2">
          <div className="flow-root">
            <ul  className="-my-2  divide-y divide-gray-200">
              {cart.map((product,item) => (
                <li key={item} className="flex py-1">
                  <div className="size-14 shrink-0 overflow-hidden rounded-md border border-gray-200">
                    <img alt={product.imageSrc} src={`${imgurl}/${product.imageSrc}`} className="size-full object-cover" />
                  </div>

                  <div className="ml-2 flex flex-1 flex-col">
                    <div>
                      <div className="flex justify-between text-sm  font-normal text-gray-900">
                        <h3>
                          <a href={product.href}>{product.name}</a>
                        </h3>
                        <p className="font-medium ml-1">{product.price*product.quantity}฿</p>
                      </div>
                      {/* <p className="mt-1 text-sm text-gray-500">{product.color}</p> */}
                    </div>
                    <div className="flex flex-1 items-end justify-between text-sm">
                    <div className="flex">
                      <PlusCircleIcon  
                          onClick={() => {
                                dispatch({
                                  type: 'plus',
                                  pdid: product.pdid,
                                  price: product.price,
                                  quantity: 1
                                  });
                              }}
                          className="h-5  w-5 text-gray-500 hover:text-green-500 hover:cursor-pointer" 
                        />                                
                      <p className="px-2  text-sm font-medium text-gray-500">{product.quantity}</p>
                      <MinusCircleIcon 
                            onClick={() => {
                                dispatch({
                                  type: 'minus',
                                  pdid: product.pdid,
                                  price: product.price,
                                  quantity: 1
                                  });
                              }}
                            className="h-5 w-5 text-gray-500 hover:text-red-500 hover:cursor-pointer" />
                      </div>
                      <div className="flex">
                        <button type="button" 
                          onClick={() => {
                            dispatch({
                              type: 'deleted',
                              pdid: product.pdid
                              });
                          }}
                            className="text-sm font-normal text-indigo-600 hover:text-indigo-500">
                          <TrashIcon  className="h-5 w-5 text-gray-500 hover:text-red-500" />
                        </button>
                      </div>
                    </div>
                  </div>
                </li>
              ))}
            </ul>
          </div>
        </div>
      </div>

      <div className="flex items-end justify-end sm:justify-center sm:w-full w-1/3">

        <div className="w-full fixed-bottom border-t border-gray-200 px-4 py-2 sm:px-4">
          <div className="flex justify-between text-base font-medium text-gray-900">
            <p>Total</p>
            <TotalPrice />
          </div>
          {/* <p className="mt-0.5 text-sm text-gray-500">Shipping and taxes calculated at checkout.</p> */}
          <div className="flex mt-2">
              <span className="w-full rounded-l-md bg-gray-200 py-1 px-4 font-normal text-gray-500 shadow-sm">
                เลขโต๊ะ
              </span>
              <input
                className="w-11 sm:w-2/5 border rounded-r-md px-2 text-black shadow-sm"
                type="number"
                name="tableNo"
                id="tableno"
                min="0"
                step="1"
                placeholder="0"
                value={order.tableNo}
                onChange={(e) => setOrder({ ...order, tableno: e.target.value})}
                onFocus={(e) => e.target.select()}
              />
            </div>
          <form className="flex">
            <input 
              type="radio" 
              id="onsite" 
              name="gettype" 
              value="ทานร้าน"  
              onChange={(e) => setOrder({ ...order, gettype: e.target.value})} 
              // onChange={handleInput}
            />
            <label htmlFor="onsite" className="px-2 text-gray-500">ทานร้าน</label><br />
            <input 
              type="radio" 
              id="takehome" 
              name="gettype" 
              value="ใส่ถุง" 
              onChange={(e) => setOrder({ ...order, gettype: e.target.value})} 
              // onChange={handleInput}
            />
            <label htmlFor="takehome" className="px-2 text-gray-500">ใส่ถุง</label><br />
          </form> 
          <div className="mt-4">
            {/* <Link
              to="/pos/checkout"
              className="flex items-center justify-center rounded-md border border-transparent bg-indigo-600 px-6 py-2 text-base font-medium text-white shadow-sm hover:bg-indigo-700"
            >
              Add Order
            </Link> */}
            <button
              type="button"
              // className="flex w-full items-center justify-center rounded-md border border-transparent bg-indigo-600 px-6 py-2 text-base font-medium text-white shadow-sm hover:bg-indigo-700"
              className={classNames(
                cart.length!==0 ? "bg-cyan-700 hover:bg-cyan-500" : "bg-slate-500" ,"flex w-full items-center justify-center rounded-md px-3 py-2 text-sm font-normal text-white shadow-sm focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-indigo-600")} 
              disabled={cart.length!==0? false : true}
              onClick={handleAddOrder}
            >
              Add Order
            </button>
          </div>
        </div>
      </div>

    </div>
  )
}
